import { inject, Injectable } from '@angular/core';
import { EventTrackingService } from '../../../../../shared/event-tracking/event-tracking.service';
import { TaskWorkspaceStore } from '../../../state/task-workspace-store';

@Injectable()
export class SplitViewService {
  private readonly taskWorkspaceStore = inject(TaskWorkspaceStore);
  private readonly eventTrackingService = inject(EventTrackingService);

  changeSplitViewOutput(
    outputName: string,
    source: string,
    shouldChangeActive = true,
  ) {
    this.taskWorkspaceStore.batch(() => {
      this.taskWorkspaceStore('splitViewOutputName').set(outputName);
      if (shouldChangeActive) {
        this.taskWorkspaceStore('selectedOutputName').set(outputName);
      }
    });

    this.trackOutputChangeEvent(outputName, source);
  }

  changeActiveOutput(outputName: string, source: string) {
    this.taskWorkspaceStore('selectedOutputName').set(outputName);
    this.trackOutputChangeEvent(outputName, source);
  }

  private trackOutputChangeEvent(activeOutputName: string, source: string) {
    this.eventTrackingService.track({
      id: 'change_active_output',
      bucket: 'navigation',
      active_output: activeOutputName,
      source,
    });
  }
}
